import { MenuProvider } from 'src/contexts/menu-context'
import { MenuDesktop } from '../Desktop/MenuDesktop'
import { MenuMobile } from '../Mobile/MenuMobile'

export const MenuWrapper = () => {
  const lg = 1024

  return (
    <MenuProvider>
      {window && window?.innerWidth < lg ? <MenuMobile /> : <MenuDesktop />}
    </MenuProvider>
  )
}
